import { ReactNode } from 'react'

import * as Styled from './styles'

interface DrawerFooterProps {
  children: ReactNode
}

export const DrawerFooter = ({ children }: DrawerFooterProps) => {
  return <Styled.DrawerFooterWrapper>{children}</Styled.DrawerFooterWrapper>
}
